import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal-container modal-container-message", { hidden: !_ctx.display }]),
    tabindex: "-1",
    role: "dialog",
    "aria-hidden": !_ctx.display,
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
    onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.escapeToClose && _ctx.escapeToClose(...args)))
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-md",
      role: "document",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stopPropagationEvent && _ctx.stopPropagationEvent(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createElementVNode("button", {
          type: "button",
          class: "modal-close-btn",
          title: _ctx.$t('Close'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, _hoisted_6, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", null, _toDisplayString(_ctx.message), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, _toDisplayString(_ctx.$t("Close")), 1)
      ])
    ])
  ], 42, _hoisted_1))
}